import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import { createContext, useContext } from "react";

interface IProtocolFormContext {
	type: ProtocolFormSchema["type"];
	hasType: boolean;
}

export const ProtocolFormContext = createContext<IProtocolFormContext>({} as IProtocolFormContext);

export function useProtocolFormContext(): IProtocolFormContext {
	return useContext(ProtocolFormContext);
}
